export default "__VITE_ASSET__oMSVQgQ9__"